import { produce } from 'immer'
import Actions from '../actions'
import { getLocale } from '../i18n'

const initialState = {
  locale: getLocale(),
  languages: {
    English: {
      name: 'English',
      locale: 'en',
      locale_display: 'EN',
      nirvana_locale: 'en-US'
    },
    Spanish: {
      name: 'Español',
      locale: 'es_US',
      locale_display: 'ES',
      nirvana_locale: 'es-ES'
    }
  }
}

export default produce((draft, action) => {
  const { payload } = action

  switch (action.type) {
    case Actions.CHANGE_LOCALE_RECEIVED: {
      // Needed for re-rendering when locale changes
      draft.locale = payload?.locale
      break
    }
    case Actions.APP_CONFIG_RECEIVED: {
      draft.languages = payload?.config?.languages
      break
    }
    default: {
      // Nothing to do
      break
    }
  }
}, initialState)
